module.exports = __webpack_public_path__ + "static/img/carousel-3.6f5bdde2.png";